// extracted by mini-css-extract-plugin
module.exports = {"box":"box--lUZZB","bannerWrap":"bannerWrap--1Zcju","all":"all--98O3h","gradient":"gradient--JlKJ-","banner":"banner--5ekMI"};